import { render, staticRenderFns } from "./BCXMessengerChatGroupPanel.vue?vue&type=template&id=15fbd28c&scoped=true"
import script from "./BCXMessengerChatGroupPanel.vue?vue&type=script&lang=ts&setup=true"
export * from "./BCXMessengerChatGroupPanel.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./BCXMessengerChatGroupPanel.vue?vue&type=style&index=0&id=15fbd28c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15fbd28c",
  null
  
)

export default component.exports